import axios from 'axios';
import Constantes from '../../store/constantes';

const API_RENTAS = Constantes.API_RENTAS;
const API_ACCESOS = Constantes.rutaAccesos;

let getAccesoLogin = (migrarUsuario,dataLogin) => {
    return axios.post(`${API_RENTAS}/acceso`,dataLogin, {params: {"guardarEnPtdGenUsuario": migrarUsuario}})
}
let getContribuyente = (nroDocumento) => {
    return axios.get(`${API_RENTAS}/contribuyente/${nroDocumento}`)
}
let getHabilitaPagina = (request) => {
    return axios.post(`${API_ACCESOS}habilitaPagina/`,request)
}
let getContribuyenteotro = (nroDocumento) => {
    return axios.get(`${API_RENTAS}/contribuyenteotro/${nroDocumento}`)
}
let getContribuyenteEstadoCuenta = (nroDocumento) => {
    return axios.get(`${API_RENTAS}/contribuyente-estadocuenta/${nroDocumento}`)
}
let getEstadoCuenta = (tdi, con, estado) => {
    return axios.get(`${API_RENTAS}/estado-cuenta/${tdi}/${con}/${estado}`)
}
let getEstadoCuentaSec = (codEmision) => {
    return axios.get(`${API_RENTAS}/estado-cuenta/${codEmision}`)
}
let getDataCuenta = (codigoCuentaRequest) => {
    return axios.post(`${API_RENTAS}/estado-cuenta/codigo-cuenta`, codigoCuentaRequest)
}
let getPredios = (codEmision) => {
    return axios.get(`${API_RENTAS}/estado-cuenta/predios/${codEmision}`)
}
let setSeleccionaPredios = (prediosSeleccionadosRequest) => {
    return axios.post(`${API_RENTAS}/estado-cuenta/selecciona-predios`, prediosSeleccionadosRequest)
}
let printEstadoCuenta = (codEmision) => {
    return axios.get(`${API_RENTAS}/estado-cuenta/imprimir-eecc/${codEmision}`)
}
let getEstadoCuentaDescarga = (dataUsuario) => {
    return axios.post(`${API_RENTAS}/estado-cuenta/descargar-eecc`, dataUsuario)
}
let getEstadoDescargaCuponera = (dniUsuario,token) => {
    return axios.get(`${API_RENTAS}/validacionCup/${dniUsuario}/${token}`)
}
let setCostaProcesal = (reciboSeleccionadosRequest) => {
    return axios.post(`${API_RENTAS}/estado-cuenta/valida-costas`, reciboSeleccionadosRequest)
}

export{
    getAccesoLogin,
    getContribuyente,
    getHabilitaPagina,
    getEstadoCuenta,
    getEstadoCuentaSec,
    getPredios,
    setSeleccionaPredios,
    printEstadoCuenta,
    getDataCuenta,
    getContribuyenteEstadoCuenta,
    getEstadoCuentaDescarga,
    getEstadoDescargaCuponera,
    getContribuyenteotro,
    setCostaProcesal
}


// WEBPACK FOOTER //
// ./src/components/services/rentasService.js